import { Component, inject, input, output, signal } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";
import { RouterLinkActive, RouterLinkWithHref } from "@angular/router";
import { AmpRouterEvent } from "@dcc/shared/amplitude";
import { ApplicationIds } from "@dcc/shared/configs/vo-applications";
import { FeatureFlagDirective } from "@dcc/shared/feature-flags/ui";
import { VdsDialog } from "@dcc/vestas-design-system/angular/components/dialog";
import { VdsDrawerComponent, VdsDrawerConfig } from "@dcc/vestas-design-system/angular/components/drawer";
import { VdsIconComponent } from "@dcc/vestas-design-system/angular/components/icon";
import { MainNavComponent, MainNavItemComponent } from "@dcc/vestas-design-system/angular/components/navigation";
import { AdminDirective } from "@dcc/vestas-online/auth/feat";
import { ApplicationAllowedDirective, HasAllowedApplicationsDirective } from "@dcc/vestas-online/shared/application-is-allowed-feature";
import { TranslocoDirective } from "@jsverse/transloco";
import { VdsStatusComponent } from "@dcc/vestas-design-system/angular/components/status";
import { LegalNoticeDialogComponent } from "../legal-notice-dialog/legal-notice.component";

@Component({
    selector: "vo-shell-nav-drawer",
    templateUrl: "./nav-drawer.component.html",
    host: {
        class: "block"
    },
    imports: [
        ApplicationAllowedDirective,
        TranslocoDirective,
        RouterLinkWithHref,
        AdminDirective,
        RouterLinkActive,
        VdsIconComponent,
        VdsDrawerComponent,
        MainNavItemComponent,
        MainNavComponent,
        NgTemplateOutlet,
        HasAllowedApplicationsDirective,
        FeatureFlagDirective,
        AmpRouterEvent,
        VdsStatusComponent
    ]
})
export class NavDrawerComponent {
    private dialog = inject(VdsDialog);

    protected readonly applicationIds = ApplicationIds;
    readonly open = input<boolean>(false);
    readonly hideDrawer = output<void>();

    protected readonly drawerConfig = signal<VdsDrawerConfig>({
        position: "left",
        width: "350px"
    });

    showLegalNotice(): void {
        this.dialog.open(LegalNoticeDialogComponent, {
            width: "1000px",
            backdropClass: "bg-black/80"
        });
    }
}
